export default "__VITE_ASSET__85c6ee0c__"